module.exports = __webpack_public_path__ + "static/media/06.c3f3569a.mp3";